import { CSSProperties, useContext, useEffect } from 'react';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import GameContext from 'contexts/GameContext';
import GlobalContext from 'contexts/GlobalContext';
import { useTableSelector } from 'hooks/useTableSelector';
import { convertToNumber } from 'utils/functions';

import CountDownTimer from 'components/Timer/CountDownTimer';
import GameModal, {
  secondaryBtnStyle,
  btnRowStyle
} from 'components/GameModal/GameModal';

const messageStyle: CSSProperties = {
  fontSize: '0.85rem',
  color: 'rgba(255, 255, 255, 0.6)',
  lineHeight: 1.5,
  textAlign: 'center'
};

const WaitForBuyInModal = () => {
  const {
    closeBuyInModal,
    openWaitForBuyIn,
    setCloseBuyInModal,
    setOpenWaitForBuyIn,
    setIsBuyinValueSet,
    setInfoMsg
  } = useContext(GlobalContext);
  const { openAddChips } = useContext(GameContext);
  const [searParams] = useSearchParams();
  const isPlayerObserver = searParams.get('observe') === 'yes' ? true : false;
  const seatId = useTableSelector((table) => table.currentPlayer.seatId);
  const bust = useTableSelector((table) => table.game.bust);
  const playersStack = convertToNumber(
    useTableSelector((table) => table.players[seatId]?.stack)
  );
  const { tabletype, languageKey, bb } = useTableSelector((table) => table.game);
  let isStartProgress =
    playersStack >= bb && languageKey === 'GAME_MSG_BUSTED_PAUSE' && bust !== null;
  const label = {
    gameTitle: 'Game Starts In...',
    gameDescription: 'Waiting for other players to buy-in.',
    btnOk: 'Okay'
  };

  const handleClose = () => {
    setOpenWaitForBuyIn(false);
    setCloseBuyInModal(true);
    setIsBuyinValueSet(false);
    setInfoMsg(false);
    isStartProgress = false;
  };

  const onComplete = () => {
    setOpenWaitForBuyIn(false);
  };

  useEffect(() => {
    if (isStartProgress && !closeBuyInModal && !openAddChips) {
      setOpenWaitForBuyIn(true);
    }
  }, [isStartProgress]);

  const isOpen = !isPlayerObserver
    ? isStartProgress &&
      openWaitForBuyIn &&
      !openAddChips &&
      tabletype !== 'm' &&
      tabletype !== 't'
    : false;

  return (
    <GameModal
      open={isOpen}
      onClose={handleClose}
      title={label.gameTitle}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CountDownTimer isStartProgress={isStartProgress} size={110} onComplete={onComplete} />
      </div>
      <div style={messageStyle}>{label.gameDescription}</div>
      <div style={btnRowStyle}>
        <button style={secondaryBtnStyle} onClick={handleClose}>
          {label.btnOk}
        </button>
      </div>
    </GameModal>
  );
};

export default WaitForBuyInModal;
